import {
  HttpEvent,
  HttpHandler,
  HttpHandlerFn,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';

import { catchError, Observable, tap, throwError } from 'rxjs';

import { ContextKey } from '../constants/context';
export class LoggingFetchService implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const start = Date.now();

    return next.handle(req).pipe(
      tap((event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse) {
          const elapsed = Date.now() - start;

          console.groupCollapsed('Fetch:', req.method, req.url, `${elapsed}ms`);
          console.log('%cELAPSED\t\t:', 'color: #885544', `${elapsed}ms`);
          console.log('%cMETHOD\t\t:', 'color: #449900', req.method);
          console.log('URL\t\t\t:', req.urlWithParams);
          console.log(
            '\t\t\t>',
            '[Version]\t\t\t:',
            req.context.get(ContextKey.ApiVersion) || '1.0'
          );
          console.log('%cBODY\t\t:', 'color: #d2691e', req.body);
          console.log('%cRESPONSE\t:', 'color: #0099ff', event.body);
          console.groupEnd();
        }
      }),
      catchError((err) => throwError(() => err))
    );
  }
}
